export default [
  {
    field: 'dateCreation',
    fixed: true,
    headerLabel: 'usage.consumption.report.table.dateCreation',
    render: true,
    type: 'date',
  },
  {
    field: 'dateCreationHour',
    fixed: true,
    headerLabel: 'usage.consumption.report.table.dateCreationHour',
    render: true,
    type: 'hour',
  },
  {
    field: 'branch',
    fixed: true,
    headerLabel: 'usage.consumption.report.table.branch',
    render: true,
    type: 'general',
  },
  {
    field: 'dsRegional',
    fixed: true,
    headerLabel: 'usage.consumption.report.table.dsRegional',
    render: true,
    type: 'general',
  },
  {
    className: 'align-right',
    field: 'cdLm',
    fixed: true,
    headerLabel: 'usage.consumption.report.table.cdLm',
    render: true,
    type: 'general',
  },
  {
    field: 'dsLm',
    fixed: true,
    headerLabel: 'usage.consumption.report.table.dsLm',
    render: true,
    type: 'general',
  },
  {
    field: 'section',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.section',
    render: true,
    type: 'general',
  },
  {
    field: 'dsSectionConsume',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.dsSectionConsume',
    render: true,
    type: 'general',
  },
  {
    className: 'align-right',
    field: 'qtInicial',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.qtInicial',
    render: true,
    type: 'decimal2',
  },
  {
    className: 'align-right',
    field: 'qtFinal',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.qtFinal',
    render: true,
    type: 'decimal2',
  },
  {
    className: 'align-right',
    field: 'qtNf',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.qtNf',
    render: true,
    type: 'decimal2',
  },
  {
    className: 'align-right',
    field: 'vlNf',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.vlNf',
    render: true,
    type: 'general',
  },

  {
    className: 'align-center',
    field: 'nbNf',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.nbNf',
    render: true,
    type: 'general',
  },

  {
    field: 'requester',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.requester',
    render: true,
    type: 'general',
  },
  {
    field: 'approver',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.approver',
    render: true,
    type: 'general',
  },
  {
    field: 'dateApproval',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.dateApproval',
    render: true,
    type: 'hour',
  },
  {
    field: 'dsJustification',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.dsJustification',
    render: true,
    type: 'general',
  },
  {
    field: 'dsJustificationDisapproval',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.dsJustificationDisapproval',
    render: true,
    type: 'general',
  },
  {
    field: 'tipStatus',
    fixed: false,
    headerLabel: 'usage.consumption.report.table.tipStatus',
    render: true,
    type: 'general',
  },
]
